import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { database } from '../../utils/firebase';
import { ref, set } from 'firebase/database';
import styles from './Display.module.scss';

import QRCode from 'react-qr-code';
import Button from '../../components/Button/Button';
import Section from '../../components/Section/Section';

import { MdChevronLeft, MdClose, MdOutlineCheck } from 'react-icons/md';
import classNames from 'classnames';
import Heading from '../../components/Heading/Heading';
import Text from '../../components/Text/Text';

const Join = ({ minPlayers, users, roomCode, startGame }) => {
  const domain = 'gyrofighters.web.app';

  const [validGame, setValidGame] = useState(false);

  useEffect(() => {
    users.forEach((user) => {
      let readyCount = 0;
      if (user.ready === true) {
        readyCount++;
      }
      if (readyCount >= minPlayers) {
        setValidGame(true);
      } else {
        setValidGame(false);
      }
    });
  }, [users, minPlayers]);

  const banPlayer = (uid, name) => {
    if (
      window.confirm(
        `Are you sure you want to ban ${name}? This is an irreverisble act`
      )
    ) {
      const userBannedRef = ref(
        database,
        `games/${roomCode}/users/${uid}/banned`
      );
      set(userBannedRef, true);
    }
  };

  const joinedList = users.map((user) => {
    if (user.banned !== true) {
      return (
        <div
          key={user.uid}
          className={styles.user}
          onClick={() => {
            banPlayer(user.uid, user.name);
          }}
        >
          <div className={styles.name}>{user.name}</div>
          <div
            className={classNames(styles.icon, {
              [styles.ready]: user.ready === true,
            })}
          >
            {user.ready ? <MdOutlineCheck /> : <MdClose />}
          </div>
        </div>
      );
    } else {
      return null;
    }
  });

  return (
    <Section className={styles.join}>
      <Link to={'/'} className={styles.exit}>
        <MdChevronLeft />
        Exit
      </Link>
      <div className={styles.qr}>
        <QRCode
          value={`https://${domain}/play?code=${roomCode}`}
          size={128}
          bgColor={'#ffffff'}
          fgColor={'#04131b'}
          level={'L'}
          title={'Join game'}
        />
      </div>
      <Text className={styles.instruction}>
        Scan the QR code on your device, or go to {domain} and enter code{' '}
        <span className={styles.code}>{roomCode}</span>
      </Text>
      {users.length > 0 && (
        <div className={styles.players}>
          <Heading className={styles.title}>Joined players:</Heading>
          <div className={styles.joined}>{joinedList}</div>
        </div>
      )}
      <Button disabled={!validGame} onClick={startGame} mute>
        {validGame ? 'Start game' : 'Waiting for players'}
      </Button>
    </Section>
  );
};

export default Join;
